interface SingleSelectionInstance {

    shouldUnselect(): void;

}

class CheckboxSingleSelectionService {

    private selections: {[singleSelectionId: string]: SingleSelectionInstance[]} = {};

    register(singleSelectionId: string, instance: SingleSelectionInstance) {
        if (!this.selections[singleSelectionId]) {
            this.selections[singleSelectionId] = [];
        }
        this.selections[singleSelectionId].push(instance);
    }

    unregister(singleSelectionId: string, instance: SingleSelectionInstance) {
        const instanceIndex = this.selections[singleSelectionId].indexOf(instance);
        if (instanceIndex > -1) {
            this.selections[singleSelectionId].splice(
                instanceIndex,
                1
            );
        }
    }

    unselectOthers(singleSelectionId: string, sourceInstance: SingleSelectionInstance) {
        const instances = this.selections[singleSelectionId];
        if (instances) {
            for (const currentInstance of instances) {
                if (currentInstance !== sourceInstance) {
                    currentInstance.shouldUnselect();
                }
            }
        }
    }

}
const CHECKBOX_SINGLE_SELECTION_SERVICE = new CheckboxSingleSelectionService();

export { CHECKBOX_SINGLE_SELECTION_SERVICE, SingleSelectionInstance };

